import { render, staticRenderFns } from "./EmployeesOrganizationTable.vue?vue&type=template&id=6c54e38f&scoped=true"
import script from "./EmployeesOrganizationTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeesOrganizationTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeesOrganizationTable.vue?vue&type=style&index=0&id=6c54e38f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c54e38f",
  null
  
)

export default component.exports